export default __webpack_public_path__ + "static/media/backPack.d31aa50b.svg";